/**
 * Inyecta en el payload de historia los datos del formulario de facturación del flujo Home
 * y metadatos internos solo para construir el JSON de Quimedik (__prefijo no existe en Laravel fillable).
 */
export function applyFacturacionDatosToHistoriaPayload(base, facturacionValues, selectedService, patientInformation) {
  const docType = String(facturacionValues?.documentType ?? '').trim();
  const rawDocInput = String(facturacionValues?.documentNumber ?? '').trim();
  /** RUC es solo dígitos; otros tipos conservan el valor sin espacios laterales */
  const docNum =
    docType === 'RUC'
      ? rawDocInput.replace(/\D/g, '')
      : rawDocInput.replace(/\s/g, '');
  const fullName = String(facturacionValues?.fullName ?? '').trim();
  const tituloServicio = selectedService?.titulo_de_tipo || 'Consulta web';
  const pacienteNombre =
    [
      patientInformation?.nombres,
      patientInformation?.apellido_paterno,
      patientInformation?.apellido_materno,
    ]
      .filter(Boolean)
      .join(' ')
      .trim() || '';

  /** Factura si eligió R.U.C. en el combo (SUNAT 6) o compatibilidad 11 dígitos como en Vue */
  const docDigitsOnly = docNum.replace(/\D/g, '');
  const isFactura = docType === 'RUC' || docDigitsOnly.length === 11;

  return {
    ...base,
    ruc_dni_en_factura: docNum || base?.ruc_dni_en_factura,
    /** Siempre lo capturado en el modal (razón social / nombre para el comprobante), sin fallback al paciente */
    nombre_razon_social_en_factura: fullName,
    tipo_de_comprobante: docNum ? (isFactura ? 'FACTURA' : 'BOLETA') : base?.tipo_de_comprobante,
    __invoice_servicio_titulo: tituloServicio,
    __invoice_paciente_completo: pacienteNombre,
    __invoice_document_type: docType,
    /** Redundancia para emisión FE si algún campo intermedio no llegara igual */
    __invoice_razon_social: fullName,
  };
}
